// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "icon-T7OVr";
var _4 = "close-20aoM";
var _5 = "paper-1QIjf";
var _6 = "conditions-1eh3Q";
var _7 = "button-nQpq3";
var _8 = "scrollBody-1mmRE";
export { _1 as "__esModule", _2 as "mobile", _3 as "icon", _4 as "close", _5 as "paper", _6 as "conditions", _7 as "button", _8 as "scrollBody" }
export default { "__esModule": _1, "mobile": _2, "icon": _3, "close": _4, "paper": _5, "conditions": _6, "button": _7, "scrollBody": _8 }
